import { TokenStorageService } from './../../../../@core/services/token-storage.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { CoreConfigService } from '@core/services/config.service';

@Component({
  selector: 'app-change-pin',
  templateUrl: './change-pin.component.html',
  styleUrls: ['./change-pin.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChangePinComponent implements OnInit {

  public contentHeader: object;

  public user: any
  public siteSettings: any = {
    site_logo: '',
    site_name: ''
  };
  submitted: boolean = false
  disable: boolean = false
  old_pin: any
  new_pin: any;

  constructor(
    private tokenStorage: TokenStorageService,
    private _coreConfigService: CoreConfigService,
    private api: ApiService
  ) {
    
  }

  /**
   * On Init
   */
  ngOnInit() {
    if (this.tokenStorage.getToken()) {
      this.user = this.tokenStorage.getUser();
    }

    // this.api.externalGet('list-service-category&serviceID=12').subscribe((response: any) => {
    //   this.selectBasic = response.data; 
    // });
    this._coreConfigService.sysConfig().subscribe(config => {
      console.log("site settings: ", config)
      this.siteSettings = config.data;
    });

    // content header
    this.contentHeader = {
      headerTitle: 'Change Pin',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/dashboard'
          },
          {
            name: 'Change Pin',
            isLink: false
          }
        ]
      }
    };
  }


  submitPin() {
    this.disable = true
    const param = {
      oldpin: this.old_pin,
      newpin: this.new_pin,
      action: 'change_pin'
    }
    this.api.post('change-details', param).subscribe((response: any) => {
      this.disable = false
      if (response.success === true) {
        this.api.alerts("top-end", "success", response.message)
      }else{
        this.api.alerts("top-end", "error", response.message)
      }
    });
    
  }

}
